import * as act from '@flux/actions/actView';
import React from 'react';
import withRouter from '@utils/wrappers/WithRouter';
import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import LayerForm from './LayerForm';
import { defaultConfigComponent } from './Layers';

const layerSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const LayerPage = props => {
  const defaultValues = {};

  return (
    <CrudPage
      key={'layerPage'}
      configComponent={defaultConfigComponent}
      form={LayerForm}
      defaultValues={defaultValues}
      validationSchema={layerSchema}
    />
  );
};

export default LayerPage;
